<template>
  <div>
    <van-nav-bar title="资金划转" left-text="返回" left-arrow @click-left="$router.push('/member/members')" />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="backgroud">
        <br>
        <van-row >
          <van-col span="8"> </van-col>
          <van-col span="8">
            <div class="capital-box">
              <div class="capital-header">
                <img src="../assets/images/timebao.png" alt="">
                <h5>当前资产</h5>
              </div>
              <br>
              <p>{{ cash }} 元</p>
            </div>
          </van-col>
          <van-col span="8"
            ><div class="capital-box">
              <router-link to="/member/platform_transfer_log"
                ><h5 style="color: #0D268D">账单 ></h5>
                </router-link
              >
            </div></van-col
          >
        </van-row>
      </div>
      <br>
      <van-row>
        
      </van-row>
      <div class="backgroud1">
        <van-row>
          <br>

          <van-col span="13">
            <div class="platformName">
              <h4>金牛港股</h4>
            </div>
          </van-col>
          <van-col span="11">
            <van-button
              class="button-out"
              type="info"
              size="normal"
              @click="openTransfer('JNHK')"
              style="height: 30px; width: 100px; margin-top: 5px;"
            >
              划转
            </van-button>
          </van-col>
        </van-row>
      </div>
      <div class="backgroud1">
        <van-row>
          <br>
          <van-col span="13">
            <div class="platformName">
              <h4>金牛美股</h4>
            </div>
          </van-col>
           <van-col span="11">
            <van-button
              class="button-out"
              type="info"
              size="normal"
              @click="openTransfer('JNUS')"
              style="height: 30px; width: 100px; margin-top: 5px;"
            >
              划转
            </van-button>
          </van-col>
        </van-row>
      </div>
    </van-pull-refresh>
    <!-- ==================== move OUT confirm popup ========================== -->

    <van-dialog v-model="moveout.status" :title="moveOutDialogTitle" show-cancel-button
      :beforeClose="moveoutBtn">
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">账户余额:</p>
        </van-col>
        <van-col span="12">
          <p style="padding-left: 30px; font-size: 14px">
            {{ cash }}元
          </p>
        </van-col>
      </van-row>
      <van-cell-group>
        <van-field type="number" v-model="moveout.money" label="金额 : " placeholder="" @input="calculateExchangeRate"/>
      </van-cell-group>
      <van-row>
        <div class="row" style="display: flex;padding-left: 15px; font-size: 14px" v-if="hk_exchange_ratio>0 && selectedPlatform.text=='JNHK'">
         <div class="col-md-8" style="display: flex;">
              </div>
            <div class="col-md-8" style="display: flex;" >
              <h5>RMB : HKD = 1:<span>{{ hk_exchange_ratio }}</span> </h5>
            </div>
             <div class="col-md-8" style="display: flex;">
              &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
             <div class="col-md-8" style="display: flex;" >
              <h5>到账金额 = <span>{{ hk_exchange_amount }}</span>港元 </h5>
            </div>
          </div>
            <div class="row" style="display: flex;padding-left: 15px; font-size: 14px" v-if="us_exchange_ratio>0 && selectedPlatform.text=='JNUS'">
         <div class="col-md-8" style="display: flex;">
              </div>
            <div class="col-md-8" style="display: flex;" >
              <h5>RMB : USD = 1:<span>{{ us_exchange_ratio }}</span> </h5>
            </div>
             <div class="col-md-8" style="display: flex;">
              &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
             <div class="col-md-8" style="display: flex;" >
              <h5>到账金额 = <span>{{ us_exchange_amount }}</span>美元</h5>
            </div>
          </div>
          </van-row>
    </van-dialog>

    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="availablePlts"
        value-key="text"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "PlatformTransfer",
  data() {
    return {
      showPicker: false,
      pickerTarget: null,
      isLoading: false,
      amount: 0,
      cash: 0,
      moveout: {
        money: 0,
        status: false,
      },
      selectedPlatform: null,
      selectedPlatformBalance: 0,
      availablePlts: [
        { text: "JNHK", value: 0 },
        { text: "JNUS", value: 1 },
      ],
      hk_exchange_ratio:0,
      us_exchange_ratio:0,
      hk_exchange_amount:0,
      us_exchange_amount:0
    };
  },
  computed: {
    platformFieldText() {
      return this.selectedPlatform ? this.selectedPlatform.text : "";
    },
   moveOutDialogTitle() {
       const name = this.selectedPlatform
        ? (this.selectedPlatform.text || this.selectedPlatform)
        : "Other Platform";

      let PlName = "";
      if (name === "JNHK") {
        PlName = "金牛港股";
      } else if (name === "JNUS") {
        PlName = "金牛美股";
      } else {
        PlName = "Other Platform";
      }

      return "划转至 " + PlName;
    }
  },
  methods: {
     calculateExchangeRate(value){
      if(this.selectedPlatform.text=='JNHK'){
           this.hk_exchange_amount=(value*this.hk_exchange_ratio).toFixed(2);
      }
      else if(this.selectedPlatform.text=='JNUS'){
           this.us_exchange_amount=(value*this.us_exchange_ratio).toFixed(2);
      }
    },
    getExchangeRatio(selectdPlt){
      let that=this;
      var transfer_plt=selectdPlt=='JNUS'?'USD':'HKD';
       that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "platform_transfer",
            token: sessionStorage.getItem("token"),
            action: "transaction_ratio",
            from: "RMB",
            to: transfer_plt
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            if(transfer_plt=='HKD'){
              that.hk_exchange_ratio=res.data.data;
            }else{
              that.us_exchange_ratio=res.data.data;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });

    },
    openPicker(target) {
    this.pickerTarget = target; 
    this.showPicker = true;
  },

  openTransfer(platformText) {
    const found = this.availablePlts.find(p => p.text === platformText);
    this.selectedPlatform = found || { text: platformText };
    this.getExchangeRatio(platformText);
     this.us_exchange_amount=0;
      this.hk_exchange_amount=0;
    this.moveout.status = true;
    this.moveout.money = 0;

  },

  onConfirm(value, index) {
    this.selectedPlatform = value;
    this.showPicker = false;
    console.log("Selected platform:", this.selectedPlatform);
  },

    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },

    mainMethod() {
      // this.getTimebaoFund();
      this.getUserinfo();
    },
    onRefresh() {
      this.mainMethod();
      this.isLoading = false;
    },

    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.movein.money = that.cash;
            // that.moveout.money = that.timebao_account;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

   moveoutBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.moveout.money;
          let request_platform = that.selectedPlatform?that.selectedPlatform['text']:'';
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: "请输入正确金额",
            });
            done(false);
          }
          else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "platform_transfer",
                  token: sessionStorage.getItem("token"),
                  action: "transferout",
                  amount: money,
                  request_platform :request_platform,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.moveout.money = 0;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          }
          break;
        case "cancel":
          done();
          break;
      }
    },
  },
  mounted() {
    this.getUserinfo();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.capital {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  color: #000000;
}

.capital p {
  margin: 0;
  color: #D02E27;
  font-size: 14px;
  font-weight: bold;
}

.capital-box {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital-box h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  color: #000000;
}

.capital-box p {
  margin: 0;
  color: #D02E27;
  font-size: 18px;
  font-weight: bold;
}
.capital-btn {
  margin-top: 10px;
  text-align: center;
}
.capital-header {
  display: flex;
  align-items: center; /* Align items in the same line */
}

.capital-header img {
  width: 25px;  
  height: 25x; 
  margin-right: 5px; 
  margin-top: -2px;
}

.backgroud {
    margin:10px 10px 5px 10px !important;
    border:1px solid #e3e3e3!important;
    border-radius: 20px !important;
    overflow: hidden;
    height: 100px;
  }
.backgroud1 {
    margin:10px 10px 5px 10px !important;
    border:1px solid #e3e3e3!important;
    border-radius: 20px !important;
    overflow: hidden;
    height: 75px;
  }
.button-in{
  background-color: #D02E27 !important;
  border: 1px solid #D02E27!important;
}
.button-out{
  background-color: #0D268D !important;
  border: 1px solid #0D268D!important;
  border-radius: 10px;
}

.button-log {
  background-color: #0D268D !important;
  border: 1px solid #0D268D !important;
}

.platformName{
  margin-top: -10px;
  text-align: center;
}
/deep/ .van-field__label {
  color: #000000 !important;   /* dark black */
  font-weight: 400;            /* optional: bold */
}
</style>



// WEBPACK FOOTER //
// src/components/PlatformTransfer.vue